<template>
  <div class="bottle" :style="{ '--s': scale }" role="img" :aria-label="`${name} bottle`">
    <span class="bottle__cap"></span>
    <span class="bottle__collar"></span>
    <span class="bottle__glass">
      <span class="bottle__liquid" :class="{ 'bottle__liquid--deep': deep }"></span>
      <span class="bottle__gloss"></span>
      <span class="bottle__edge"></span>
      <span v-if="showLabel" class="bottle__label">
        <span class="bottle__mark">CHER</span>
        <span class="bottle__name">{{ name }}</span>
        <span class="bottle__meta">{{ meta }}</span>
      </span>
      <span v-else class="bottle__mark bottle__mark--bare">CHER</span>
    </span>
    <span class="bottle__shadow"></span>
  </div>
</template>

<script>
export default {
  name: 'PerfumeBottle',
  props: {
    name: { type: String, required: true },
    meta: { type: String, default: 'Eau de Parfum' },
    scale: { type: Number, default: 1 },
    showLabel: { type: Boolean, default: true },
    deep: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.bottle {
  width: calc(var(--s) * 118px);
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: calc(var(--s) * 44px);
}
.bottle__cap {
  width: calc(var(--s) * 48px);
  height: calc(var(--s) * 40px);
  position: absolute;
  top: 0;
  border-radius: calc(var(--s) * 3px) calc(var(--s) * 3px) calc(var(--s) * 2px) calc(var(--s) * 2px);
  background: linear-gradient(90deg, #16130f 0%, #40382e 14%, #6b5f51 27%, #2b251e 46%, #171410 66%, #4c4338 86%, #201c17 100%);
  box-shadow:
    inset 0 calc(var(--s) * -5px) calc(var(--s) * 7px) rgba(0, 0, 0, .5),
    inset 0 calc(var(--s) * 2px) 0 rgba(255, 255, 255, .18);
}
.bottle__collar {
  width: calc(var(--s) * 36px);
  height: calc(var(--s) * 11px);
  margin-bottom: calc(var(--s) * -3px);
  background: linear-gradient(90deg, #7e7568 0%, #ded7cb 26%, #fdfbf7 42%, #c3bbae 62%, #8a8175 82%, #6f665b 100%);
  box-shadow: inset 0 calc(var(--s) * -2px) calc(var(--s) * 3px) rgba(51, 42, 33, .35);
}
.bottle__glass {
  width: 100%;
  height: calc(var(--s) * 154px);
  position: relative;
  overflow: hidden;
  border-radius: calc(var(--s) * 9px) calc(var(--s) * 9px) calc(var(--s) * 15px) calc(var(--s) * 15px);
  background:
    linear-gradient(90deg,
      rgba(120, 100, 76, .22) 0%,
      rgba(255, 255, 255, .62) 7%,
      rgba(255, 255, 255, .16) 20%,
      rgba(255, 255, 255, .05) 48%,
      rgba(255, 255, 255, .18) 74%,
      rgba(255, 255, 255, .66) 91%,
      rgba(120, 100, 76, .26) 100%),
    linear-gradient(180deg, rgba(255, 255, 255, .42), rgba(226, 214, 197, .28));
  box-shadow:
    inset 0 0 0 1px rgba(255, 255, 255, .5),
    inset 0 calc(var(--s) * -16px) calc(var(--s) * 20px) rgba(122, 96, 64, .22),
    0 calc(var(--s) * 14px) calc(var(--s) * 20px) rgba(46, 33, 20, .22);
}
.bottle__liquid {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 58%;
  background: linear-gradient(180deg, #e0ab68 0%, #c07f3f 44%, #8f5326 100%);
}
.bottle__liquid--deep { background: linear-gradient(180deg, #a9713f 0%, #7d4620 45%, #4a2711 100%); }
.bottle__liquid::before {
  content: '';
  height: calc(var(--s) * 9px);
  position: absolute;
  top: calc(var(--s) * -4px);
  right: 0;
  left: 0;
  border-radius: 50%;
  background: rgba(255, 236, 205, .5);
}
.bottle__gloss {
  width: calc(var(--s) * 12px);
  height: 74%;
  position: absolute;
  top: calc(var(--s) * 9px);
  left: calc(var(--s) * 12px);
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(255, 255, 255, .9), rgba(255, 255, 255, .1));
  filter: blur(calc(var(--s) * 1.6px));
}
.bottle__edge {
  width: calc(var(--s) * 6px);
  height: 78%;
  position: absolute;
  top: calc(var(--s) * 12px);
  right: calc(var(--s) * 9px);
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(255, 255, 255, .5), rgba(255, 255, 255, .04));
  filter: blur(calc(var(--s) * 2px));
}
.bottle__label {
  width: 78%;
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: calc(var(--s) * 3px);
  padding: calc(var(--s) * 8px) calc(var(--s) * 5px);
  transform: translate(-50%, -50%);
  text-align: center;
  background: linear-gradient(180deg, rgba(252, 249, 243, .95), rgba(238, 230, 218, .9));
  box-shadow: 0 calc(var(--s) * 2px) calc(var(--s) * 6px) rgba(58, 41, 24, .2);
}
.bottle__mark {
  color: #241f19;
  font-family: mulegh, Georgia, serif;
  font-size: calc(var(--s) * 17px);
  line-height: .9;
  letter-spacing: calc(var(--s) * 1px);
}
.bottle__mark--bare {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #2c2620;
}
.bottle__name {
  color: #4b4239;
  font-size: calc(var(--s) * 7px);
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: calc(var(--s) * .6px);
  text-transform: uppercase;
  overflow-wrap: anywhere;
}
.bottle__meta {
  color: #8d8274;
  font-size: calc(var(--s) * 5px);
  letter-spacing: calc(var(--s) * 1.1px);
  text-transform: uppercase;
}
.bottle__shadow {
  width: 128%;
  height: calc(var(--s) * 13px);
  margin-top: calc(var(--s) * -3px);
  border-radius: 50%;
  background: radial-gradient(ellipse at center, rgba(48, 34, 20, .42), rgba(48, 34, 20, 0) 70%);
  filter: blur(calc(var(--s) * 2.5px));
}
</style>
